import '../ticket/new_ticket_view.js.coffee';# Added by Script 
import '../ticket/ticket_view.js.coffee';# Added by Script 
Customer.Tabs ||= {}

class Customer.Tabs.TabManagerView extends Backbone.View

  initialize: (@options = {}) ->
    tabViews = @options.tabViews || throw new Error('Cannot instantiate a TabManagerView without tabViews')
    @filterEventHandler = @options.filterEventHandler;
    listElement = @options.listEl || throw new Error('Cannot instantiate a TabManagerView without a listEl')
    newCaseView = new Customer.Dashboard.NewCaseView({ tabManagerView: @, data: @options }) if @options.enableNewCase
    @tabListView = new Customer.Tabs.TabListView(el: listElement, tabViews: tabViews, newCaseView: newCaseView)
    @principalView = new Customer.Dashboard.PrincipalView({ tabManagerView: @, tabViews: tabViews, data: @options, el: @options.principalContainer })
    @openedFilters = {}

    @listenTo(@tabListView, 'selected:tab', @onSelectTab)
    @listenTo(@tabListView, 'closed:tab', @onCloseTab)
    @listenTo(@tabListView, 'refresh:tab', @onRefreshTab)

    containerElement = @options.containerEl || throw new Error('Cannot instantiate a TabManagerView without a containerEl')
    activeView = @tabListView.getActiveView()

    @containerView = new Customer.Tabs.SmartContainerView(el: containerElement, activeView: activeView)

  render: ->
    @tabListView.render()
    @containerView.render()
    @principalView.render()
    @

  onSelectTab: (tabbableView, refresh=false) ->
    @containerView.setActiveView(tabbableView, refresh)
    @openedFilters[tabbableView.selectedFilter.id] = tabbableView.selectedFilter if tabbableView.selectedFilter
    @trigger('selected:tab', tabbableView) # for external consumption
    isTicketView = tabbableView instanceof Customer.Ticket.TicketView || tabbableView instanceof Customer.Ticket.NewTicketView
    @principalView.togglePrincipalShortcut(isTicketView)
    if isTicketView
      $('#tabs-wrapper').removeClass('filters-header-space')
      $('#tabs').removeClass('filters-header-space')
    else
      $('#tabs-wrapper').addClass('filters-header-space')
      $('#tabs').addClass('filters-header-space')
    tabbableView.trigger('focus:in') if tabbableView.trigger

  getOpenedFilters: ->
    array_values = [];
    for key,value of @openedFilters
      array_values.push(@openedFilters[key]);
    array_values

  onCloseTab: (tabbableView) ->
    try
      tabbableView.onCloseTab()
      delete @openedFilters[tabbableView.selectedFilter.id] if tabbableView.selectedFilter
      @containerView.discardView(tabbableView)
      @trigger('closed:tab', tabbableView) # for external consumption
    catch error
      jsLogger.error("onCloseTab error tabbableView type " + tabbableView?.constructor?.name + " - #{error}")

  onRefreshTab: (tabbableView) ->
    @trigger('refresh:tab', tabbableView) # for external consumption

  changeToTab: (tabView, refresh=false) ->
    @tabListView.changeToTab(tabView)
    @discardView(tabView.tabbableView) if refresh
    @onSelectTab(tabView.tabbableView, refresh)

  discardView: (tabbleView) ->
    @containerView.discardView(tabbleView)

  startTabRefresh: () ->
    @tabListView.getActiveTab().startTabRefresh()

  finishTabRefresh: () ->
    @tabListView.getActiveTab().finishTabRefresh()

  tabIsLoaded: (tabId) ->
    @tabListView.hasTab(tabId) 

  addNewTab: (newTab) ->
    @tabListView.addTab(newTab)
    if !@tabListView.getActiveTab().isVisible()
      @tabListView.onSelectTab(newTab.tabId(), true)    

  updateTabView: (tabbableView, tabId) ->
    tab = @tabListView.tabView(tabId)
    tab.renewTab(tabbableView) if tab
    if @tabListView.getActiveTab().tabId() == tabId
      @tabListView.onSelectTab(tabId, true)

  highlightTab: (tabId, tabType) ->
    return if @tabListView.getActiveTab().tabId() == tabId || !@tabListView.hasTab(tabId) 
    @tabListView.tabView(tabId).highlight(tabType)
